var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotifyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#6be3a2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#324561",
    d: "M35.643,21.502c-0.155,0-0.313-0.036-0.461-0.113c-6.745-3.517-14.513-4.338-21.873-2.308 c-0.533,0.147-1.083-0.166-1.229-0.698s0.166-1.083,0.698-1.229c7.847-2.164,16.134-1.29,23.328,2.462 c0.49,0.255,0.68,0.859,0.425,1.349C36.352,21.307,36.004,21.502,35.643,21.502z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#324561",
    d: "M33.055,27.272c-0.153,0-0.309-0.035-0.455-0.11c-5.427-2.78-11.677-3.455-17.603-1.901 c-0.533,0.142-1.081-0.179-1.221-0.713c-0.141-0.534,0.179-1.081,0.713-1.221c6.398-1.68,13.154-0.95,19.022,2.056 c0.491,0.252,0.686,0.854,0.434,1.346C33.769,27.073,33.418,27.272,33.055,27.272z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#324561",
    d: "M30.354,32.938c-0.147,0-0.298-0.033-0.439-0.103c-4.056-1.992-8.722-2.51-13.13-1.462 c-0.543,0.125-1.078-0.205-1.204-0.742c-0.128-0.537,0.204-1.076,0.741-1.204c4.865-1.153,10.005-0.582,14.474,1.613 c0.496,0.243,0.7,0.842,0.457,1.338C31.078,32.733,30.723,32.938,30.354,32.938z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyLogo);
export default __webpack_public_path__ + "static/media/spotify-logo.a2055370fb7823b05bf8934ae8893d15.svg";
export { ForwardRef as ReactComponent };